import {dynamicWrapper, createRoute} from '@/utils/core';

const routesConfig = app => ({
    path: '/homepage/transact',
    title: '首页',
    component: dynamicWrapper(app, [import('./model/index')], () => import('./components/index'))
});

export default app => createRoute(app, routesConfig);
